import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'moment/locale/uk';
import debounce from 'lodash/debounce';
import { cancelFormChange, repeatFormChange } from 'actions/changeHistory';
import { getCallStation, setCallReceptionStatus, resumeSseSession } from 'actions/call';
import { killEvent } from 'helpers';
import { openUserPopup } from 'actions/ui';
import { sessionStorageService } from 'services/settingsService';
import { LocalDBProvider } from 'store/localDB';
import permissions, { checkPermissions } from './config/permissions';
import AppRouter from './router';

import './styles/shared.scss';
import './styles/style.scss';
import 'react-select/dist/react-select.css';

const mapStateToProps = (state) => ({
	operations: state.user.operations,
	userLogin: state.user.login,
});

const mapDispatchToProps = (dispatch) => ({
	cancelFormChange: () => dispatch(cancelFormChange()),
	repeatFormChange: () => dispatch(repeatFormChange()),
	openUserPopup: () => dispatch(openUserPopup()),
	setCallReceptionStatus: status => dispatch(setCallReceptionStatus(status)),
	getCallStation: () => dispatch(getCallStation()),
	resumeSseSession: (userLogin) => dispatch(resumeSseSession(userLogin)),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class App extends React.Component {
	constructor(props) {
		super(props);

		this.hasAttemptedSseResume = false;
	}

	componentDidUpdate(prevProps) {
		if (this.props.operations.length && !prevProps.operations.length && checkPermissions(permissions.CallOperations.action_workPbx)) {
			this.props.getCallStation();
		}

		this.maybeResumeSse();
	}

	componentDidMount() {
		// Custom Ctrl+Z and Ctrl+Shift+Z handlers.
		document.addEventListener('keyup', debounce(event => {
			if (event.keyCode === 90 && (event.ctrlKey || event.metaKey)) {
				if (event.shiftKey) {
					this.props.repeatFormChange();
				} else {
					this.props.cancelFormChange();
				}

				killEvent(event);
			}
		}, 50));

		// Preventing default browser handlers for Ctrl+Z, Ctrl+Shift+Z and Ctrl+Cmd+Z.
		document.addEventListener('keydown', event => {
			if (event.keyCode === 90 && (event.ctrlKey || event.metaKey)) {
				killEvent(event);
			}
		});

		document.addEventListener('keypress', event => {
			if (event.keyCode === 90 && (event.ctrlKey || event.metaKey)) {
				killEvent(event);
			}
		});

		const isOpenedBefore = sessionStorageService.get('isUserPopupOpenedBefore');

		if (!isOpenedBefore) {
			this.props.setCallReceptionStatus('active');
			this.props.openUserPopup();
		}

		if (this.props.operations.length && checkPermissions(permissions.CallOperations.action_workPbx)) {
			this.props.getCallStation();
		}

		this.maybeResumeSse();
	}

	maybeResumeSse = () => {
		if (this.hasAttemptedSseResume) {
			return;
		}

		if (!this.props.operations.length || !checkPermissions(permissions.CallOperations.action_workPbx)) {
			return;
		}

		this.hasAttemptedSseResume = true;
		this.props.resumeSseSession(this.props.userLogin);
	};

	render() {
		return (
			<LocalDBProvider>
				<AppRouter />
			</LocalDBProvider>
		);
	}
}

App.propTypes = {
	requestDictionary: PropTypes.func,
	repeatFormChange: PropTypes.func,
	cancelFormChange: PropTypes.func,
	openUserPopup: PropTypes.func,
	getCallStation: PropTypes.func,
	resumeSseSession: PropTypes.func,
	setCallReceptionStatus: PropTypes.func,
	showCreateNewCustomerModal: PropTypes.bool,
	showCreateNewContactPersonModal: PropTypes.bool,
	showNotificationPanel: PropTypes.bool,
	notifications: PropTypes.any,
	operations: PropTypes.array,
	userLogin: PropTypes.string,
};
